import { render } from "./zdspList.vue?vue&type=template&id=f713fdc2&scoped=true"
import script from "./zdspList.vue?vue&type=script&lang=js"
export * from "./zdspList.vue?vue&type=script&lang=js"

import "./zdspList.vue?vue&type=style&index=0&id=f713fdc2&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f713fdc2"]])

export default __exports__